module.exports = __webpack_public_path__ + "img/key.dc52594e.svg";